import { render, staticRenderFns } from "./TreatmentEpisodeMemoBox.vue?vue&type=template&id=216961ec&scoped=true&"
import script from "./TreatmentEpisodeMemoBox.vue?vue&type=script&lang=ts&"
export * from "./TreatmentEpisodeMemoBox.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentEpisodeMemoBox.vue?vue&type=style&index=0&id=216961ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216961ec",
  null
  
)

export default component.exports